import { ActionTypes } from './types';
import { getMachineInstances, getMachineSize } from './Selectors';
import { setCustomData } from '../Configurator/Actions';

const getMaxInstanceX = (instances, machineSize) => {
  const { width, length } = machineSize;
  const px = width * 0.5,
    pz = length * 0.5;
  const ranges = [];
  for (const { x, rotation } of instances) {
    const pxCosA = px * Math.cos(rotation);
    const pzSinA = pz * Math.sin(rotation);
    const boxPointsX = [pxCosA - pzSinA, -pxCosA - pzSinA, -pxCosA + pzSinA, pxCosA + pzSinA];
    const txMax = Math.max(...boxPointsX) + x;
    const txMin = Math.min(...boxPointsX) + x;
    ranges.push({ txMax, txMin });
  }
  ranges.sort((a, b) => a.txMax - b.txMax);
  for (let i = 0; i < ranges.length - 1; i++) {
    if (ranges[i + 1].txMin - ranges[i].txMax > width + 2) {
      return ranges[i].txMax;
    }
  }
  return ranges.length ? ranges[ranges.length - 1].txMax : 0;
};

const getPlaceForInstance = (instances, machineSize) => {
  const maxX = getMaxInstanceX(instances, machineSize);
  return {
    x: !instances.length ? 0 : maxX + machineSize.width + 1,
    z: 0,
    rotation: 0,
  };
};

export const addInitialInstance = () => (dispatch, getState) => {
  if (!getMachineInstances(getState()).length) {
    dispatch(addInstance());
  }
};

export const addInstance = () => (dispatch, getState) => {
  const state = getState();
  const instances = getMachineInstances(state);
  const machineSize = getMachineSize(state);
  return dispatch(
    setCustomData({
      instances: [...instances, getPlaceForInstance(instances, machineSize)],
    })
  );
};

export const setSelectedInstanceId = (instanceId) => ({
  type: ActionTypes.SET_SELECTED_INSTANCE_ID,
  instanceId,
});

export const removeInstance = (instanceId) => (dispatch, getState) => {
  const instances = [...getMachineInstances(getState())];
  instances.splice(instanceId, 1);
  return dispatch(
    setCustomData({
      instances,
    })
  );
};
